import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { REDUCER_NAME } from 'src/reducers/clients/semiMonthlyPayment';
import { SelectField } from 'src/jbc-front/components/Form';
import { getLabeledDays } from 'src/reducers/selectOptions';
import { PAYROLL_RULES_GROUP_FORM } from 'src/constants/FormNames';
import { getItem } from 'src/reducers/common/itemReducer';
import { calculatePaymentDateOptions } from '../utils';

import { HalfContainer } from '../styles';

const SecondHalfSetting = ({
  hasConfirmedPays,
  closingDay,
  paymentDay,
  paymentMonthType,
  firstHalfStartDate,
  days,
  closingDaySecondHalf
}) => {
  const [paymentDaysOptions, setPaymentDaysOptions] = useState([]);
  const { t } = useTranslation();
  const isNextMonth = paymentMonthType === 'next_month';

  useEffect(
    () => {
      const options = {
        startDay: isNextMonth ? firstHalfStartDate : closingDay,
        endDay: isNextMonth ? closingDay : closingDaySecondHalf,
        isSecondHalf: true,
        isNextMonth
      };
      const newPaymentDateOptions = calculatePaymentDateOptions(options, paymentMonthType);
      setPaymentDaysOptions(newPaymentDateOptions);
    },
    [closingDay, firstHalfStartDate, paymentDay]
  );

  return (
    <>
      {closingDay &&
        paymentDay && (
          <HalfContainer>
            <h3>{t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.second_half')}</h3>
            <SelectField
              name="secondHalfStartDate"
              label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.start')}
              disabled
              required
              options={days}
            />
            <SelectField
              name="closingDaySecondHalf"
              label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.second_half_cut_off_date')}
              disabled
              required
              options={days}
            />
            <SelectField
              required
              label={t('features.PayrollRulesGroups.containers.PayrollRulesGroupForm.second_half_payment_date')}
              name="paymentDaySecondHalf"
              disabled={hasConfirmedPays}
              options={paymentDaysOptions}
            />
          </HalfContainer>
        )}
    </>
  );
};

const mapStateToProps = state => ({
  days: getLabeledDays(state),
  hasConfirmedPays: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'hasConfirmedPays'),
  firstHalfStartDate: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'firstHalfStartDate'),
  closingDay: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'closingDay'),
  closingDaySecondHalf: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'closingDaySecondHalf'),
  paymentDay: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'paymentDay'),
  paymentMonthType: _.get(getFormValues(PAYROLL_RULES_GROUP_FORM)(state), 'paymentMonthType'),
  semiMonthlyPayment: getItem(REDUCER_NAME, state) || {}
});

export default connect(mapStateToProps)(SecondHalfSetting);
